import { HTMLTemplateElement, TAGNAME_TEMPLATE, TypeError } from "@acng/frontend-bounty/types";
import { append, createElement, getElementById, head, setId } from "@acng/frontend-bounty";
/**
 * @typedef {import("../model/resource.js").ResourceElement} ResourceElement
 */
const UUID_STARGAZER_ROOT = "711dc75f-9b29-4a29-bb81-9ed27a5f4259";
/**
 * @internal
 */
export const rootNamespace = (() => {
    let root = 
    /**
     * @type {ResourceElement}
     */
    (getElementById(UUID_STARGAZER_ROOT));
    if (!root) {
        root = createElement(TAGNAME_TEMPLATE);
        setId(root, UUID_STARGAZER_ROOT);
        append(head, root);
    }
    if (root instanceof HTMLTemplateElement) {
        return root;
    }
    throw TypeError(UUID_STARGAZER_ROOT);
})();
